import React from 'react';
import AppLoadingScreen from '../ui/AppLoadingScreen';

const LoadingSpinner = () => {
  return <AppLoadingScreen />;
};

export default LoadingSpinner;
